<template>
  <div class="container">
    <full-width-image-carousel
      :images="images"
      :swiper_config="swiper_config"
      :swiper_breakpoints="swiper_breakpoints"
    />
  </div>
</template>

<script>

import Swiper from "../modules/Swiper/Swiper.vue";
import SwiperSlide from "../modules/Swiper/SwiperSlide.vue";
import LazyImage from "../small_parts/LazyImage.vue";
import uid_mixin from "../../mixins/uid_mixin";
import FullWidthImageCarousel from "../parts/FullWidthImageCarousel.vue";

export default {
  name: "ImageCarousel",
  mixins: [uid_mixin],
  components: {
    FullWidthImageCarousel,
    LazyImage,
    SwiperSlide,
    Swiper
  },
  props: {
    /**props**/
    images: {
      type: Array,
      default: () => [],
      admin_type: 'array',
      array_values: {
        image_src: {
          type: String,
          required: true,
          admin_type: 'image',
        },
        image_lazy_src: {
          type: String,
          default: '',
          admin_type: 'image',
        },
      }
    }
    /**props**/
  },
  computed: {
    swiper_config() {
      return {
        spaceBetween: 20,
      }
    },
    swiper_breakpoints() {
      return {
        576: {
          slidesPerView: 1,
          spaceBetween: 20
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 20
        },
      }
    },
  }
}
</script>
